import { useQuery } from '@tanstack/react-query'
import { qk } from 'api'
import { getLanguagesList } from 'api/languages'

export const useLanguagesList = () => {
  const { data: allLanguages } = useQuery(
    qk.languages.list.toKey(),
    getLanguagesList,
  )

  return { allLanguages }
}
